/**
 * App Configuration
 * 
 * FREE_MODE - Przełącznik między wersją darmową a płatną
 * 
 * true  = Wersja DARMOWA - wszystko za darmo, bez subskrypcji
 * false = Wersja PŁATNA - subskrypcje, promowanie, ograniczenia
 * 
 * Aby przełączyć na wersję płatną, zmień FREE_MODE na false
 */

export const FREE_MODE = true;

// Ceny (używane tylko gdy FREE_MODE = false)
export const PRICES = {
  subscription: {
    monthly: 15, // zł netto/mies
    yearly: 150, // zł netto/rok
  },
  promotion: {
    weekly: 25, // zł netto/7 dni
  }
};

// Teksty dla różnych trybów
export const MODE_TEXTS = {
  free: {
    ctaButton: "Rozpocznij za darmo",
    registerButton: "Zarejestruj się za darmo",
  },
  paid: {
    ctaButton: "Rozpocznij za darmo",
    registerButton: "Zarejestruj firmę",
  }
};
